export default "__VITE_ASSET__CBnZZtCL__"